import React from 'react'

import styles from './DonutChart.scss';

import {Spacer} from 'components';

const DonutChart = (props) => {



  let factor = Math.pow(10, 0);
  let percentage = Math.round(props.value * factor) / factor

  let halfsize = (props.size * 0.5);
  let radius = halfsize - (props.strokewidth * 0.5);
  let circumference = 2 * Math.PI * radius;
  let strokeval = ((percentage * circumference) / 100);
  let dashval = (strokeval + ' ' + circumference);

  let trackstyle = {strokeWidth: props.strokewidth};
  let indicatorstyle = {strokeWidth: props.strokewidth, strokeDasharray: dashval}
  let rotateval = 'rotate(-90 '+halfsize+','+halfsize+')';



  let extraStyles  = {
    marginTop:'-'+ (props.size / 2 - 25) +'px'
  }

  let overlay =       <div className={styles.content}  style={extraStyles}>
                          <span style={{ fontSize: (props.fontSizeL) }}>{percentage}%</span>
                          <div style={{ fontSize: (props.fontSizeS) }}>{props.valuelabel}</div>
                      </div>

  if(props.value == 0){
    overlay =       <div className={styles.content}  style={extraStyles}>
                        <Spacer height="24px" style={{ fontSize: (props.fontSizeL) }} />
                        <div style={{ fontSize: (props.fontSizeS) }}>{props.value0label}</div>
                    </div>
  }

  let classNames = styles.chart
  if(props.align == 'center'){
    classNames = classNames + ' ' + styles.isCenter
  }

  if(props.font == 'large'){
    classNames = classNames + ' ' + styles.isLargeFont
  }

  if(props.noPrint){
    classNames = classNames + ' ' + styles.noPrint
  }

  return (
    <div className={classNames}>
      <svg width={props.size} height={props.size} className={styles.donutchart}>
        <circle r={radius} cx={halfsize} cy={halfsize} transform={rotateval} style={trackstyle} className={styles.donutchartTrack} />
        <circle r={radius} cx={halfsize} cy={halfsize} transform={rotateval} style={indicatorstyle} className={styles.donutchartIndicator}/>
      </svg>
      {overlay}
    </div>
  )
}

export default DonutChart


// WEBPACK FOOTER //
// ./src/components/atoms/DonutChart/index.js